import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
import axios, { isCancel, AxiosError } from 'axios';
import Swal from 'sweetalert2'

Alpine.plugin(persist);

window.axios = axios;
window.Swal = Swal;

window.Alpine = Alpine;
Alpine.start();
